<template>
    <div>
        <v-toolbar
            flat
            dense
        >
            <span class="changelog-title">{{ app_name }} Change Log</span>
        </v-toolbar>
        <v-card-text class="changelog-content">
            <v-tabs-items v-model="focusedVersion">
                <v-tab-item
                    v-for="(ver, index) in releaseNotes"
                    :key="ver.version"
                >
                    <div class="changelog-version-block">
                        <h2 class="changelog-version-header">{{ ver.title }}</h2>
                        <p class="changelog-version-desc">{{ ver.description }}</p>
                    </div>
                    <div 
                        v-if="ver.features && ver.features.length"
                        class="changelog-section"
                    >
                        <h3 class="changelog-section-header">
                            <v-icon small color="primary" class="changelog-section-icon">mdi-star</v-icon>
                            New Features
                        </h3>
                        <ul class="changelog-list">
                            <li v-for="feature in ver.features" :key="feature.title" class="changelog-list-item">
                                <div class="changelog-item-title">{{ feature.title }}</div>
                                <div class="changelog-item-desc" v-html="feature.description.replace(/\n/g, '<br>')"></div>
                            </li>
                        </ul>
                    </div>
                    <div 
                        v-if="ver.bugfixes && ver.bugfixes.length"
                        class="changelog-section"
                    >
                        <h3 class="changelog-section-header">
                            <v-icon small color="success" class="changelog-section-icon">mdi-bug-check</v-icon>
                            Bug Fixes & Improvements
                        </h3>
                        <ul class="changelog-list">
                            <li v-for="bugfix in ver.bugfixes" :key="bugfix.title" class="changelog-list-item">
                                <div class="changelog-item-title">{{ bugfix.title }}</div>
                                <div class="changelog-item-desc" v-html="bugfix.description.replace(/\n/g, '<br>')"></div>
                            </li>
                        </ul>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-card-text>
        <v-card-actions
            style="background: rgba(0,0,0,0.05);padding: 8px 24px;display: flex;max-width: 700px;flex-direction: row;align-items: center;border-radius: 0 0 12px 12px;"
        >
            <div class="changelog-tabs-wrapper">
                <v-tabs
                    v-if="allVersions().length > 1"
                    v-model="focusedVersion"
                    color="transparent"
                    slider-color="blue"
                    style="overflow-x: scroll;"
                >
                    <v-tab
                        v-for="(ver, index) in allVersions()"
                        :key="ver"
                        :value="ver"
                        @click="focusedVersion = index"
                    >
                        {{ ver }}
                    </v-tab>
                </v-tabs>
            </div>
            <v-btn
                @click="$emit('close')"
                flat
                color="red"
            >
                Close
            </v-btn>
        </v-card-actions>
    </div>
</template>

<script>
import GlobalConstants from '@/globals'

export default {
  name: 'ChangeLog',
  props: ['version'],
  data () {
    return {
      releaseNotes: GlobalConstants.ReleaseNotes,
      focusedVersion: 0
    }
  },
  methods: {
    allVersions () {
        return this.releaseNotes.map(r => r.version)
    }
  }
}
</script>

<style lang="css" scoped>


.changelog-container {
    max-width: 700px;
    margin: 0 auto;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    font-family: 'Inter', 'Roboto', Arial, sans-serif;
}
.changelog-toolbar {
    background: linear-gradient(90deg, #1976d2 0%, #42a5f5 100%);
    color: #fff;
    font-size: 1.3rem;
    font-weight: 600;
    border-radius: 12px 12px 0 0;
    padding: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.changelog-title {
    font-size: 1.2em;
    font-weight: 700;
}
.changelog-content {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 500px;
    padding: 24px 32px 16px 32px;
}
.changelog-version-block {
    margin-bottom: 18px;
}
.changelog-version-header {
    text-align: left;
    font-size: 1.5em;
    font-weight: 700;
    margin-bottom: 4px;
    color: #1976d2;
}
.changelog-version-desc {
    font-size: 1.1em;
    color: #555;
    margin-bottom: 12px;
}
.changelog-section {
    margin-bottom: 22px;
}
.changelog-section-header {
    display: flex;
    align-items: center;
    font-size: 1.15em;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 4px;
}
.changelog-section-icon {
    margin-right: 8px;
}
.changelog-list {
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
}
.changelog-list-item {
    margin-bottom: 14px;
    padding: 12px 16px;
    background: #f7fafd;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(66,165,245,0.04);
    transition: box-shadow 0.2s;
}
.changelog-list-item:hover {
    box-shadow: 0 2px 8px rgba(66,165,245,0.10);
}
.changelog-item-title {
    font-size: 1.08em;
    font-weight: 600;
    color: #1976d2;
    margin-bottom: 2px;
}
.changelog-item-desc {
    font-size: 1em;
    color: #444;
}
.changelog-tabs-wrapper {
    flex: 1 1 auto;
    min-width: 0;
}

</style>